export const CLEAR_CHARTS = 'CLEAR_CHARTS';
export const CHARTS_FOR_EXPORT = 'CHARTS_FOR_EXPORT';
export const EXPAND_DRAW_SHAPE_PANEL = 'EXPAND_DRAW_SHAPE_PANEL';
export const FETCHING_LAYER_INFO = 'FETCHING_LAYER_INFO';
export const HISTOGRAM_RESULTS = 'HISTOGRAM_RESULTS';
export const INIT_MAP = 'INIT_MAP';
export const LAYER_INFO_RECEIVED = 'LAYER_INFO_RECEIVED';
export const LOADER_ACTIVE = 'LOADER_ACTIVE';
export const MAPVIEW_LOAD_ERROR = 'MAPVIEW_LOAD_ERROR';
export const REPORT_IS_AVAILABLE = 'REPORT_IS_AVAILABLE';
export const SAVE_SNAPSHOT = 'SAVE_SNAPSHOT';
export const SHOW_ANALYSIS = 'SHOW_ANALYSIS';
export const TOGGLE_VISIBLE_LAYER = 'TOGGLE_VISIBLE_LAYER';
export const PRECALCULATED_CSV_DATA = 'PRECALCULATED_CSV_DATA';
export const PRECALCULATED_SHAPE = 'PRECALCULATED_SHAPE';
export const TOGGLE_BASEMAP_SELECTOR = 'TOGGLE_BASEMAP_SELECTOR';
export const USER_DRAWN_POLYGON = 'USER_DRAWN_POLYGON';
export const TOTAL_AREA = 'TOTAL_AREA';
export const SET_MAP_LAYERS = 'SET_MAP_LAYERS';
export const YEARS_SELECTED = 'YEARS_SELECTED';
